// JsFromRoutes CacheKey a946e0ff4637d491f220d36126d330f6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/gift_lists/:gift_list_id/gift_list_items/:id'),
}
